import type { TourDefinition, TourId } from './tours.types';
import { DASHBOARD_TOUR } from './definitions/dashboard.tour';
import { PROFILE_TOUR } from './definitions/perfil.tour';
import { FIRST_CERTIFICATE_HINT_TOUR } from './definitions/first-certificate-hint.tour';
import { CERTIFICATE_ADD_TOUR } from './definitions/certificate-add.tour';
import { FIRST_ADD_CERTIFICATE_TOUR } from './definitions/first-add-certificate.tour';
import { MODAL_ASSOCIATE_GROUPS_TOUR } from './definitions/modal-associate-groups.tour';
import { STEP1_CREATE_LOTE_TOUR } from './definitions/step1_create_lote.tour';
import { STEP2_CARGA_DOCUMENTOS_TOUR } from './definitions/step2_carga_documentos.tour';
import { CASE1_FIRMA_ASICIACION_GRUPOS_TOUR } from './definitions/case1-firma-asociacion-grupos.tour';
import { AREAS_FIRMA_GRUPOS_TOUR } from './definitions/areas_firma_grupos.tour';
import { AREAS_FIRMA_PLANTILLA_TOUR } from './definitions/areas_firma_plantilla.tour';
import { FIRMAR_DOCUMENTO_TOUR } from './definitions/firmar-documento.tour';
import { MODAL_AGREGAR_GRUPOS_TOUR } from './definitions/modal-agregar-grupos.tour';
import { MODAL_AGREGAR_CERTIFICADO_BUSQUEDA_TOUR } from './definitions/modal-agregar-certificado-busqueda.tour';
import { MODAL_AGREGAR_CERTIFICADO_SELECCION_TOUR } from './definitions/modal-agregar-certificado-seleccion.tour';
import { CASE2_FIRMA_ASICIACION_SIN_PLANTILLA_TOUR } from './definitions/case2-firma-asociacion-sin-plantilla';


export const TOURS: Record<TourId, TourDefinition> = {
  dashboard_help: DASHBOARD_TOUR, 
  profile_help: PROFILE_TOUR,
  first_certificate_hint: FIRST_CERTIFICATE_HINT_TOUR,
  certificate_add_help: CERTIFICATE_ADD_TOUR , 
  first_add_certificate: FIRST_ADD_CERTIFICATE_TOUR , 
  modal_associate_groups_help: MODAL_ASSOCIATE_GROUPS_TOUR,
  step1_create_lote_help: STEP1_CREATE_LOTE_TOUR , 
  step2_carga_documentos_help: STEP2_CARGA_DOCUMENTOS_TOUR , 
  case1_firma_asociacion_grupos_help: CASE1_FIRMA_ASICIACION_GRUPOS_TOUR , 
  areas_firma_grupos_help: AREAS_FIRMA_GRUPOS_TOUR , 
  areas_firma_plantilla_help: AREAS_FIRMA_PLANTILLA_TOUR,
  firmar_documento_help: FIRMAR_DOCUMENTO_TOUR,
  modal_agregar_grupos_help: MODAL_AGREGAR_GRUPOS_TOUR , 
  modal_agregar_certificado_busqueda_help: MODAL_AGREGAR_CERTIFICADO_BUSQUEDA_TOUR,
  modal_agregar_certificado_seleccion_help: MODAL_AGREGAR_CERTIFICADO_SELECCION_TOUR,
  case2_firma_asociacion_sin_plantilla_help: CASE2_FIRMA_ASICIACION_SIN_PLANTILLA_TOUR
};
